module.exports = __webpack_public_path__ + "img/28.b6ce7c86.png";